import { render, staticRenderFns } from "./MatchActivities.vue?vue&type=template&id=1d39772c&"
import script from "./MatchActivities.vue?vue&type=script&lang=js&"
export * from "./MatchActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports